export const matchesFilter = (filter, item) => {
  return Object.entries(filter).every(([key, value]) => item[key] === value);
};

export function withFilters(filters) {
  return item => filters.every(f => matchesFilter(f, item));
}
